import React, { forwardRef } from 'react'

import { classes } from '../utils'

export const IndeterminateSpinner = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>(({ className, color, ...rest }, ref) => (
  <svg
    ref={ref}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes('animate-[spin_1.5s_linear_infinite]', className)}
    {...rest}
  >
    <path
      d="M20 5V12.5M20 27.5V35M9.3934 9.3934L14.6967 14.6967M25.3033 25.3033L30.6066 30.6066M4.99988 20H12.4999M27.5001 20H35.0001M9.3934 30.6066L14.6967 25.3033M25.3033 14.6967L30.6066 9.3934"
      stroke={color || 'currentColor'}
      strokeWidth="2.5"
    />
  </svg>
))
IndeterminateSpinner.displayName = 'IndeterminateSpinner'

export default IndeterminateSpinner
